module.exports = __webpack_public_path__ + "img/oce-play.707010bf.svg";